/**
 * Upcoming Events Widget Container
 *
 * App-layer container that connects the presentational
 * {@link UpcomingEventsWidget} to the family-calendar store.
 *
 * @module app/widgets/UpcomingEventsWidgetContainer
 */

import { useCalendarStore } from '@/features/family-calendar/stores/calendarStore';
import { UpcomingEventsWidget } from '@/shared/components/widgets/UpcomingEventsWidget';

interface UpcomingEventsWidgetContainerProps {
  readonly count?: 3 | 5 | 10;
  readonly className?: string;
  readonly showHeader?: boolean;
  readonly showEmptyState?: boolean;
}

export function UpcomingEventsWidgetContainer(
  props: UpcomingEventsWidgetContainerProps
) {
  const events = useCalendarStore((state) => state.events);
  const labels = useCalendarStore((state) => state.labels);
  return <UpcomingEventsWidget {...props} events={events} labels={labels} />;
}
